import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils.js';

export function Textarea({
  className,
  ...props
}: ComponentProps<'textarea'>): React.ReactNode {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex min-h-16 w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-elev-1 transition-[color,box-shadow] outline-none',
        'placeholder:text-muted-foreground field-sizing-content',
        'focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/30',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'md:text-sm',
        className,
      )}
      {...props}
    />
  );
}
